<template lang="pug">
  td.col.marking(:class="job.marked ? 'on' : ''")
    span(v-if="!!job.company_id" @click="toggle") マーキング

</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    props: ['job', 'updateMarkForIndex'],
    data () {
      return {
        marked: this.job.marked,
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    methods: {
      ...mapActions('jobMark', ['add', 'remove']),
      async toggle () {
        if (this.job.marked) {
          if (this.job.job_mark_user !== this.user.name) {
            return
          }
        }

        this.$store.commit('common/lockGlobal')
        try {
          this.job.marked
            ? await this.remove({ id: this.job.company_id })
            : await this.add({ id: this.job.company_id })
          if (this.updateMarkForIndex) {
            this.$store.commit('job/mark', { ids: this.job.company_id, newMarked: !this.job.marked, markUser: this.user.name })
          }
          this.$store.commit('common/unlockGlobal')
          this.$emit('update')
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobTableMark.vue